// removed by extract-text-webpack-plugin
module.exports = {"pho_cont":"components-stuPhotoMng-index-pho_cont-15AV-","avator":"components-stuPhotoMng-index-avator-2uApO","name":"components-stuPhotoMng-index-name-2CZEV","id":"components-stuPhotoMng-index-id-2-bu5","pto_popover":"components-stuPhotoMng-index-pto_popover-3LX7u","search_box":"components-stuPhotoMng-index-search_box-1klI_"};


//////////////////
// WEBPACK FOOTER
// ./components/stuPhotoMng/index.css
// module id = 1918
// module chunks = 0